<template>
  <div class="tags-view-container">
    <scroll-pane ref="scrollPane" class="tags-view-wrapper">
      <router-link
        v-for="tag in visitedViews"
        ref="tag"
        :class="isActive(tag) ? 'active' : ''"
        :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
        :key="tag.path"
        tag="span"
        class="tags-view-item"
        @click.middle.native="closeSelectedTag(tag)"
        @contextmenu.prevent.native="openMenu(tag, $event)">
        {{ tag.title }}
        <span class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)"></span>
      </router-link>
    </scroll-pane>
    <ul v-show="visible" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu">
      <li @click="refreshSelectedTag(selectedTag)">刷新</li>
      <li v-if="selectedTag.name !== 'dashboard'" @click="collectTag(selectedTag)">
        收藏
      </li>
      <li @click="closeSelectedTag(selectedTag)">关闭</li>
      <li @click="closeOthersTags">关闭其它</li>
      <li @click="closeAllTags">关闭所有</li>
      <li @click="openPagePermission">页面权限</li>
    </ul>
    <!-- 页面权限 -->
    <Recombination ref="Recombination" :title="'页面权限     '+`     ${pageName}`" :icon-flag="false" top="10vh" width="1000" @handleBeforeClose="handleBeforeClose">
      <div slot="body">
        <transition name="animated" enter-active-class="animated fadeInLeft" leave-active-class="animated fadeOutRight">
          <PagePermission ref="pagePermission"/>
        </transition>
      </div>
    </Recombination>
  </div>
</template>

<script>
import ScrollPane from '@/components/ScrollPane'
import PagePermission from './PagePermission'
import { AddToMyFavorite } from '@/api/common'
import Sortable from 'sortablejs'
import Recombination from '@/components/Recombination'
export default {
  components: { ScrollPane, Recombination, PagePermission },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      pageName: '',
      dialogVisible: true
    }
  },
  computed: {
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    }
  },
  watch: {
    $route() {
      this.addViewTags()
      this.moveToCurrentTag()
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  mounted() {
    this.addViewTags()
    window.addEventListener('beforeunload', (e) => {
      this.visitedViews.forEach((element) => {
        if (
          element.query.isClearStorage == 'true' &&
          element.name !== this.$route.name
        ) {
          this.$store.dispatch('delView', element)
        }
      })
    })
    this.rowDrop()
  },
  methods: {
    isActive(route) {
      return route.path === this.$route.path
    },
    addViewTags() {
      const { name } = this.$route
      if (name) {
        this.$store.dispatch('addView', this.$route)
        const route = {
          path: window.location.href
        }
        parent.postMessage({
          cmd: 'jinjiaIframe',
          params: route
        }, '*')
      }
      return false
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to.path === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag)
            // when query is different then update
            if (tag.to.fullPath !== this.$route.fullPath) {
              // this.$store.dispatch("updateVisitedView", tag.to);
              // window.history.replaceState({}, "", "/#" + tag.to.fullPath);
              this.$store.dispatch('updateVisitedView', this.$route)
              window.history.replaceState({}, '', '/#' + this.$route.fullPath)
            }

            break
          }
        }
      })
    },
    refreshSelectedTag(view) {
      this.$store.dispatch('delCachedView', view).then(() => {
        const { fullPath } = view
        this.$nextTick(() => {
          this.$router.replace({
            path: '/redirect' + fullPath,
            query: {
              t: +new Date() // 保证每次点击路由的query项都是不一样的，确保会重新刷新view
            }
          })
        })
      })
    },
    // 收藏
    collectTag(view) {
      AddToMyFavorite({
        path: view.path,
        name: view.name,
        title: view.title,
        system_id: '2'
      }).then((response) => {
        if (response.data.res_status_code === '0') {
          this.$message({
            type: 'success',
            message: this.$t('message.collectsuc')
          })
        } else {
          this.$message({
            type: 'error',
            message: response.data.res_message
          })
        }
      })
    },
    closeSelectedTag(view) {
      this.$store.dispatch('delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          const latestView = visitedViews.slice(-1)[0]
          if (view.query.backUrl) {
            this.$router.push({
              name: view.query.backUrl,
              query: {
                t: view.query.parent_t
              }
            })
          } else if (view.query.backPath) {
            const quaryParams = {
              controller_label: view.query.controller_label,
              function_name: view.query.function_name,
              id: view.query.ids
            }
            const { controller_label, function_name, id } = quaryParams // 在报表中心会有这几个参数
            const query = controller_label && function_name && id ? { t: view.query.parent_t, ...quaryParams } : { t: view.query.parent_t }
            this.$router.push({
              path: view.query.backPath,
              query: query
            })
          } else {
            if (latestView) {
              const { path, query } = latestView
              this.$router.push({
                path,
                query
              })
            } else {
              this.$router.push('/')
            }
          }
        }
      })
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag)
      this.$store.dispatch('delOthersViews', this.selectedTag).then(() => {
        this.moveToCurrentTag()
      })
    },
    closeAllTags() {
      this.$store.dispatch('delAllViews')
      this.$router.push('/')
    },
    openMenu(tag, e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      const offsetWidth = this.$el.offsetWidth // container width
      const maxLeft = offsetWidth - menuMinWidth // left boundary
      const left = e.clientX - offsetLeft + 15 // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft
      } else {
        this.left = left
      }
      this.top = e.clientY

      this.visible = true
      this.selectedTag = tag
    },
    closeMenu() {
      this.visible = false
    },
    handleBeforeClose() {
      this.$refs.pagePermission.resetInfo()
    },
    // 页面权限
    openPagePermission() {
      const {
        path,
        meta: { title }
      } = this.selectedTag
      if (path === '/') {
        this.$message({
          showClose: true,
          message: '首页无页面权限',
          type: 'warning'
        })
        return
      }
      this.pageName = title
      this.$refs.Recombination.handleOpenDialog()
      this.$nextTick(() => {
        this.$refs.pagePermission.initInfo()
      })
    },
    rowDrop() {
      const el = document.querySelector('.tags-view-wrapper .el-scrollbar__wrap .el-scrollbar__view') // 找到想要拖拽的那一列
      const _this = this
      this.sortable = Sortable.create(el, {
        draggable: '.tags-view-item', // Class name for the drop placeholder,
        onEnd: ({ newIndex, oldIndex }) => {
          const currRow = _this.visitedViews.splice(oldIndex, 1)[0] // 鼠标拖拽当前的el-tabs-pane
          _this.visitedViews.splice(newIndex, 0, currRow)
        }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.tags-view-container {
  height: 34px;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  border-top: 1px solid #d8dce5;
  .tags-view-wrapper {
    .tags-view-item {
      display: inline-block;
      position: relative;
      cursor: pointer;
      height: 26px;
      line-height: 26px;
      border: 1px solid #d8dce5;
      color: #495060;
      background: #fff;
      padding: 0 8px;
      font-size: 12px;
      margin-left: 5px;
      margin-top: 4px;
      &:first-of-type {
        margin-left: 15px;
      }
      &:last-of-type {
        margin-right: 15px;
      }
      &.active {
        background-color: #4d939f;
        color: #fff;
        border-color: #4d939f;
        &::before {
          content: '';
          background: #fff;
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          position: relative;
          margin-right: 2px;
        }
      }
    }
  }
  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 100;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
  }
}
</style>

<style rel="stylesheet/scss" lang="scss">
//reset element css of el-icon-close
.tags-view-wrapper {
  .tags-view-item {
    .el-icon-close {
      width: 16px;
      height: 16px;
      vertical-align: 2px;
      border-radius: 50%;
      text-align: center;
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      transform-origin: 100% 50%;
      &:before {
        transform: scale(0.6);
        display: inline-block;
        vertical-align: -3px;
      }
      &:hover {
        background-color: #b4bccc;
        color: #fff;
      }
    }
  }
}
</style>
